import { NavItemType } from 'types/menu';

// assets
import { CalendarOutlined, ContactsOutlined, MessageOutlined } from '@ant-design/icons';
import { ALL_USER_GROUPS, CALENDAR_MEDIA_OFFICERS } from 'utils/route-guard/roles-check';

const tools: NavItemType = {
    id: 'group-tools',
    title: 'Tools',
    type: 'group',
    allowedGroups: ALL_USER_GROUPS,
    children: [
        {
            id: 'calendar',
            title: 'Calendar',
            type: 'collapse',
            icon: CalendarOutlined,
            allowedGroups: [CALENDAR_MEDIA_OFFICERS],
            children: [
                {
                    id: 'calendar-list',
                    title: 'Active calendars',
                    type: 'item',
                    url: '/calendar/all',
                    childrenUrl: [
                        '/calendar/:id/events',
                        '/calendar/details/:id',
                        '/calendar/details/:id/events/:eventId',
                        '/calendar/history/:id',
                        '/calendar/history/:id/event/:eventId',
                    ],
                    allowedGroups: [CALENDAR_MEDIA_OFFICERS],
                },
                {
                    id: 'calendar-archived-list',
                    title: 'Archived calendars',
                    type: 'item',
                    url: '/calendar/archived',
                    allowedGroups: [],
                },
                {
                    id: 'country-list',
                    title: 'Countries',
                    type: 'item',
                    url: '/country/all',
                    allowedGroups: [],
                },
                {
                    id: 'venue-list',
                    title: 'Venues',
                    type: 'item',
                    url: '/venue/all',
                    allowedGroups: [],
                },
                {
                    id: 'venue-type-list',
                    title: 'Venue Types',
                    type: 'item',
                    url: '/venue-type/all',
                    allowedGroups: [],
                },
                {
                    id: 'city-list',
                    title: 'Host Cities',
                    type: 'item',
                    url: '/city/all',
                    allowedGroups: [],
                },
                {
                    id: 'team-list',
                    title: 'Teams',
                    type: 'item',
                    url: '/team/all',
                    allowedGroups: [],
                },
            ],
        },
        {
            id: 'contact',
            title: 'Contact tools',
            type: 'collapse',
            icon: ContactsOutlined,
            allowedGroups: [],
            children: [
                {
                    id: 'contact-list',
                    title: 'All contacts',
                    type: 'item',
                    url: '/contact/all',
                    allowedGroups: [],
                },
                {
                    id: 'job-title-list',
                    title: 'Job Titles',
                    type: 'item',
                    url: '/job-title/all',
                    allowedGroups: [],
                },
                {
                    id: 'contact-type-list',
                    title: 'Contact Types',
                    type: 'item',
                    url: '/contact-type/all',
                    allowedGroups: [],
                },
                {
                    id: 'contact-category-list',
                    title: 'Contact Category',
                    type: 'item',
                    url: '/contact-category/all',
                    allowedGroups: [],
                },
            ],
        },
        {
            id: 'message',
            title: 'Messaging',
            type: 'collapse',
            icon: MessageOutlined,
            allowedGroups: [],
            children: [
                {
                    id: 'message-draft-list',
                    title: 'Draft messages',
                    type: 'item',
                    url: '/message/draft',
                    allowedGroups: [],
                },
                {
                    id: 'message-live-list',
                    title: 'Live messages',
                    type: 'item',
                    url: '/message/live',
                    allowedGroups: [],
                },
                {
                    id: 'message-archived-list',
                    title: 'Archived messages',
                    type: 'item',
                    url: '/message/archived',
                    allowedGroups: [],
                },
                {
                    id: 'message-history-list',
                    title: 'History of messages',
                    type: 'item',
                    url: '/message/history',
                    allowedGroups: [],
                },
            ],
        },
    ],
};

export default tools;
